module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper border-bottom white-bg page-heading"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 col-lg-8"
  }, [(_vm.loading) ? _c('heading-loading') : _c('h1', [_c('i', {
    staticClass: "far fa-money-check-alt m-r-sm"
  }), _vm._v(" Payment #" + _vm._s(_vm.paymentDecorated.xero_number))])], 1), _vm._v(" "), (_vm.notLoading) ? _c('div', {
    staticClass: "col-sm-4 col-lg-4"
  }, [(!_vm.paymentDecorated.isPaid) ? _c('p', {
    staticClass: "invoice-due"
  }, [_vm._v("Paid: " + _vm._s(_vm.paymentDecorated.paid))]) : _c('p', {
    staticClass: "invoice-due complete"
  }, [_vm._v("Paid")])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-5f6313e5"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/ShowHeading.vue
// module id = 1018
// module chunks = 0